import {
  ClusterLimitsPolicyV2,
  NodeDownscalerPolicyV2,
  UnschedulablePodsPolicyV2,
} from '@cast/types-cluster-autoscaler';

export enum PolicyKey {
  UnschedulablePods = 'unschedulablePods',
  NodeDownscaler = 'nodeDownscaler',
  ClusterLimits = 'clusterLimits',
}

type Policies = {
  [PolicyKey.ClusterLimits]: ClusterLimitsPolicyV2;
  [PolicyKey.NodeDownscaler]: NodeDownscalerPolicyV2;
  [PolicyKey.UnschedulablePods]: UnschedulablePodsPolicyV2;
};

export type PoliciesList = Record<
  keyof Policies,
  { label: string; enabled: boolean }
>;
